import { insertTrackEvent } from './common.js';

const sowPageLoad = () => {
	insertTrackEvent({
		category: 'Sidebar',
		action: `Source Of Wealth - Opened`,
		label: 'Sow Loaded'
	});
};

const sowOptionsSelect = textKeys => {
	insertTrackEvent({
		category: 'Sidebar',
		action: `Source Of Wealth - Source selection`,
		label: textKeys
	});
};

const sowAttachedFiles = numberOfFiles => {
	insertTrackEvent({
		category: 'Sidebar',
		action: `Source Of Wealth - Document`,
		label: numberOfFiles
	});
};

const sowSuccessfulUploads = textkeys => {
	insertTrackEvent({
		category: 'Sidebar',
		action: `Source Of Wealth - Submitted`,
		label: textkeys
	});
};

const sowErrorUploads = errorCode => {
	insertTrackEvent({
		category: 'Sidebar',
		action: `Source Of Wealth - Submission Failed`,
		label: errorCode
	});
};

const sowStateOnExit = formState => {
	insertTrackEvent({
		category: 'Sidebar',
		action: `Source Of Wealth - Dismissed`,
		label: formState
	});
};

export { sowPageLoad, sowOptionsSelect, sowAttachedFiles, sowSuccessfulUploads, sowErrorUploads, sowStateOnExit };
